import { Dt } from "../../../plugins/datatable";
import { getData, CSRF } from "../../../helpers";
import { create, edit } from "./modals/store";
import { showVideo } from "./modals/play";

export const videos = () => {
    // console.info("*-*-* videos *-*-*");
    const CurrentSection = document.querySelector(
        "[data-current-section=videos]"
    ); // Identificar la sección
    const BtnNew = CurrentSection.querySelector("[name=new]"); // Identificar el botón para crear
    const TableVideos = CurrentSection.querySelector("#dtVideos");

    // Eventos
    BtnNew?.addEventListener("click", () => {
        create(
            BtnNew.getAttribute("data-url"),
            BtnNew.getAttribute("data-title")
        );
    });

    TableVideos.addEventListener("click", (e) => {
        const Target = e.target.closest(".target");

        if (Target) {
            if (Target.classList.contains("edit")) {
                edit(
                    Target.getAttribute("data-url"),
                    Target.getAttribute("data-title"),
                    Target.getAttribute("data-data")
                );
            }
        }
    });

    // Start DataTable
    let configDt = {
        processing: true, // Procesar ajax
        serverSide: true, // Mejorar velocidad ajax registros por página
    };

    configDt.ajax = {
        url: getData("#urlDtVideos"),
        type: "POST",
        beforeSend: function (request) {
            request.setRequestHeader("X-CSRF-TOKEN", CSRF);
        },
    };
    // Columnas del AJAX
    configDt.columns = [
        { data: "DT_RowIndex", width: "3%", className: "text-center" },
        {
            data: "image",
            width: "5%",
            className: "text-center",
            orderable: false,
        },
        { data: "name" },
        { data: "description" },
        { data: "play", width: "5%", className: "text-center" },
        { data: "front", width: "12%" },
        {
            data: "status",
            width: "7%",
            className: "text-center",
            orderable: false,
        },
        {
            data: "buttons",
            width: "5%",
            className: "text-center",
            orderable: false,
        },
    ];

    const DtVideos = new Dt(configDt);
    DtVideos.dataTable("#dtVideos");
    // End DataTable
};
